export async function getUserData() {
    let url = '/' + window.locale + '/api/user-data';
    let params = new URLSearchParams(window.location.search).toString();
    if (params) {
        url += '?'+params;
    }
    try {
        const response = await fetch(url, {
            method: "GET",
        });

        if (response.ok) {
            const data = await response.json();
            fillUserData(data);
        } else {
            console.error(`User data request failed: ${response.status}`);
            fillUserData(null);
        }
    } catch (error) {
        console.error(`User data response failed: ${error}`);
        fillUserData(null);
    }
}

function fillUserData(userData = null) {
    if(userData == null) {
        clearSessionLoginState();
        return;
    }

    if(userData.csrf) {
        document.querySelector('meta[name="csrf-token"]').setAttribute("content", userData.csrf);

        let csrfFields = document.querySelectorAll('input[name="_token"]');
        csrfFields.forEach(element => {
            element.value = userData.csrf;
        });
    }

    if(userData.display_name) {
        updateUserNavElements(true, userData.display_name, userData.avatar, userData.regional_restrictions, userData.account);
    } else {
        clearSessionLoginState();
    }
    if(userData.notification) {
        const NotificationHolder = document.getElementById('notificationHolder');
        if (NotificationHolder) {
            NotificationHolder.innerHTML = userData.notification;
        }
    }
    if(userData.ratings_board) {
        const FooterRatings = document.querySelector('.FooterRatingsContainer-ratings');
        if (FooterRatings) {
            FooterRatings.innerHTML = userData.ratings_board;
        }
    }

    if(userData.regional_restrictions) {
        if(userData.regional_restrictions.signup) {
            const FormHolder = document.querySelector('#signupLightbox .formHolder');
            if (FormHolder) {
                FormHolder.innerHTML = '<div class="restrictedSignup">'+userData.regional_restrictions.signup+'</div>';
            }
            const SubmitButton = document.querySelector('body.signup .signup-form #submit-btn button');
            if (SubmitButton) {
                SubmitButton.disabled = true;
            }
        }
    }

    if(userData.account && userData.account.amazonRedeemLink) {
        const RedeemLink = document.querySelector('.HeaderUserMenu-claimLink');
        if (RedeemLink) {
            RedeemLink.href = userData.account.amazonRedeemLink;
        }
    }

    setAnalyticsUserProperties(userData);
}


const analyticsUserPropWhitelist = Array('display_name', 'country_code', 'site_language', 'userId', 'masteryRank', 'platinum', 'coupon', 'twitchLinked', 'amazonLinked', 'game_platform');
function setAnalyticsUserProperties(userData)
{
    if (typeof analytics === 'undefined')
    {
        return;
    }
    let camel_to_snake = (str) => str.replace(/(\B)([A-Z])/, '_$2').toLowerCase();
    let user_props = {};
    for (const [key, value] of Object.entries(userData)) {
        if (analyticsUserPropWhitelist.indexOf(key) !== -1) {
            user_props[camel_to_snake(key)] = value;
        }
    }
    if (userData.account) {
        for (const [key, value] of Object.entries(userData.account)) {
            if (analyticsUserPropWhitelist.indexOf(key) !== -1) {
                user_props[camel_to_snake(key)] = value;
            }
        }
        if (userData.account.amazonRedeemable)
        {
            user_props['amazon_state'] = 'redeem';
        }
        else if (userData.account.amazonAvailable)
        {
            user_props['amazon_state'] = 'claim';
        }
        else
        {
            user_props['amazon_state'] = 'none';
        }
    }
    analytics.set_user_properties(user_props);

    analytics.event("user_properties_ready")
        .properties({"authenticated": !!userData.account })
        .push();
}

const SESSION_STORAGE_LOGIN_STATE = "wfSessionShouldBeLoggedIn";
const SESSION_STORAGE_LOGGED_IN = "isLoggedIn";

function clearSessionLoginState() {
    if (safeSessionStorage()) {
        sessionStorage.removeItem(SESSION_STORAGE_LOGIN_STATE);
    }
    const body = document.querySelector('body');
    body.classList.toggle('logged-in', false);
    body.classList.toggle('loaded-in', false);
    body.classList.toggle('logged-out', true);
}

function safeSessionStorage() {
    try {
        return sessionStorage;
    } catch (e) {
        return false;
    }
}

let queryString = location.search;
let navDisplayName = '-';

function updateUserNavElements(loggedIn, displayName, avatar, regionalRestrictions, account={}) {
    loggedIn = !!loggedIn;
    let body = document.querySelector('body');
    if (loggedIn) {
        body.classList.toggle('logged-in', loggedIn);
        body.classList.toggle('loaded-in', loggedIn);
        body.classList.toggle('logged-out', !loggedIn);
        if (safeSessionStorage()) {
            sessionStorage.setItem(SESSION_STORAGE_LOGIN_STATE, SESSION_STORAGE_LOGGED_IN);
        }
    } else {
        clearSessionLoginState();
    }
    if (!displayName) {
        displayName = '-';
    }

    if (window.isLoggedIn === loggedIn && navDisplayName === displayName) {
        return; //nothing changed
    }
    window.isLoggedIn = loggedIn;
    navDisplayName = displayName;

    let loggedInElements = document.querySelectorAll('.logged-in');
    let loggedOutElements = document.querySelectorAll('.not-logged-in');

    if(loggedIn) {
        const userData = {...account, avatar};
        Warframe.setUserData(displayName, regionalRestrictions, userData);

        loggedInElements.forEach(element => {
            element.classList.remove('login-hide');
        });
        loggedOutElements.forEach(element => {
            element.classList.add('login-hide');
        });
    } else {
        loggedInElements.forEach(element => {
            element.classList.add('login-hide');
        });
        loggedOutElements.forEach(element => {
            element.classList.remove('login-hide');
        });
    }
}
